import React, { useEffect, useState, useContext } from "react"
import styled from "styled-components"
import { Form, Loader } from "semantic-ui-react"
import { FilterContext } from "../../providers/FilterProvider"

const Container = styled.div`
  margin-top: 22px;
  padding: 0 22px 0;
`

const StyledForm = styled(Form)`
  margin: 0 22px !important;
  display: flex;
  align-items: center;
  margin-left: 0 !important;
  margin-right: 0 !important;

  .mobile-price-range {
    height: 18px;
    margin: 0 !important;
    width: 100% !important;

    input {
      padding: 0 !important;
    }

    /*Chrome*/
    @media screen and (-webkit-min-device-pixel-ratio: 0) {
      input[type="range"] {
        //overflow: hidden;
        outline: none;
        width: 180px;
        border-radius: 12px;
        -webkit-appearance: none;
        background-color: ${props => props.theme.colors.green};
      }

      input[type="range"]::-webkit-slider-runnable-track {
        height: 10px;
        -webkit-appearance: none;
        color: blue;
        margin-top: -1px;
      }

      input[type="range"]::-webkit-slider-thumb {
        width: 20px;
        -webkit-appearance: none;
        height: 20px;
        border-radius: 50%;
        cursor: ew-resize;
        background: #fff;
        margin-top: -5px;
        border: 2px solid ${props => props.theme.colors.green};
      }
    }
    /** FF*/
    input[type="range"]::-moz-range-progress {
      background-color: ${props => props.theme.colors.green};
    }
    input[type="range"]::-moz-range-track {
      background-color: ${props => props.theme.colors.green};
    }
    /* IE*/
    input[type="range"]::-ms-fill-lower {
      background-color: ${props => props.theme.colors.green};
    }
    input[type="range"]::-ms-fill-upper {
      background-color: ${props => props.theme.colors.green};
    }
  }
`

const Price = styled.span`
  position: relative;
  margin: 0 6px;
  width: 50px;
  white-space: nowrap;
`

const LowestPrice = styled(Price)`
  margin-left: 0;
  text-align: left;
`

const HighestPrice = styled(Price)`
  margin-right: 0;
`

const Label = styled.label`
  display: block;
  color: #555;
  text-align: center;
  margin-bottom: 4px;
  visibility: ${props => (props.visible ? "visible" : "hidden")};
  font-size: 16px;
`

function MobilePriceRange() {
  const { state, dispatch } = useContext(FilterContext)
  const [duration, setDuration] = useState("")

  const lowestPrice = () => {
    const prices = [...state.products].map(products => products.productPrice)
    const lowest = Math.min(...prices)

    if (lowest === Infinity) {
      return ""
    }

    return lowest
  }

  const highestPrice = () => {
    const prices = [...state.products].map(products => products.productPrice)
    const highest = Math.max(...prices)

    if (highest === -Infinity) {
      return ""
    }

    return highest
  }

  useEffect(() => {
    setDuration(highestPrice())

    const input = document.querySelector(".mobile-price-range input")
    if (!input) return

    input.addEventListener("touchend", e =>
      dispatch({ priceRange: e.target.value })
    )
  }, [state.products])

  return (
    <Container>
      <Label visible={duration}>Pris fra {duration} kr</Label>
      <StyledForm>
        <LowestPrice>
          {state.products.length ? (
            `${lowestPrice()} kr`
          ) : (
            <Loader style={{ marginRight: "-10px" }} size="tiny" active />
          )}
        </LowestPrice>
        <Form.Input
          className="mobile-price-range"
          min={lowestPrice()}
          max={highestPrice()}
          name="duration"
          step={1}
          type="range"
          value={duration}
          onChange={e => setDuration(e.target.value)}
        />
        <HighestPrice>
          {state.products.length ? (
            `${highestPrice()} kr`
          ) : (
            <Loader style={{ marginLeft: "-10px" }} size="tiny" active />
          )}
        </HighestPrice>
      </StyledForm>
    </Container>
  )
}

export default MobilePriceRange
